export default {
	"message": {
		"temperturePerson": "sms notification of abnormal temperature",
		"transferPerson": "confirm person of shipping order",
		"dispatcher": "dispatch person of shipping order",
		"specifyPerson": "designated notifier",
		"limitationPerson": "sms notification of abnormal time limit",
		"mailPerson": "scheduling mail cc person",
		"scheduPerson": "scheduling sms cc person"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/message/message.js